var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import infoIcon from "./../../assets/img/icons/info-icon.svg";
import infoAlert from "./../../assets/img/icons/info-alert.svg";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import classNames from "classnames";
import { connect } from "react-redux";
var messages = defineMessages({
    profile_symbols: {
        id: "profile.symbols",
        defaultMessage: "6-32 символа"
    },
    profile_minimum_symbols: {
        id: "profile.minimum_symbols",
        defaultMessage: "Минимум 6 символов, включая 1 цифру и 1 заглавную букву"
    },
    profile_min_length_new_pass: {
        id: "profile.min_length_new_pass",
        defaultMessage: "Новый пароль должен содержать не менее 6 символов"
    },
    profile_pointed_already: {
        id: "profile.pointed_already",
        defaultMessage: "Данный номер уже используется"
    },
    profile_pointed_email_already: {
        id: "profile.pointed_email",
        defaultMessage: "Данный e-mail уже используется"
    },
    profile_inValid_phoneNumber: {
        id: "profile.inValid_phoneNumber",
        defaultMessage: "Пожалуйста, введите ваш номер телефона в формате {formatCountry}XXXXXXXXX. пример: {formatCountry}555123456"
    },
    profile_inValid_date: {
        id: "profile.inValid_date",
        defaultMessage: "Пожалуйста, введите дату в формате ДД.ММ.ГГГГ"
    },
});
var ProfileInput = /** @class */ (function (_super) {
    __extends(ProfileInput, _super);
    function ProfileInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLableSite: false,
            isShowedInfo: false,
            error: null,
        };
        _this.getErrorMessage = function (errorNumber) {
            if (_this.props.formType !== 'password') {
                switch (errorNumber) {
                    case -2:
                        return {
                            name: "phone",
                            message: _this.props.intl.formatMessage(__assign({}, messages.profile_pointed_already))
                        };
                    case -3:
                        return {
                            name: "email",
                            message: _this.props.intl.formatMessage(__assign({}, messages.profile_pointed_email_already))
                        };
                    default:
                        return { name: null };
                }
                return null;
            }
            switch (errorNumber) {
                case -1:
                    alert('серверная ошибка');
                    break;
                case -2:
                    return {
                        name: "CurrentPassword",
                        message: _this.props.intl.formatMessage({
                            id: "withdraw.withdraw_form_wrong_password"
                        })
                    };
                case -3:
                    return {
                        name: "Password",
                        message: _this.props.intl.formatMessage(__assign({}, messages.profile_min_length_new_pass))
                    };
                default:
                    return null;
            }
        };
        _this.inputRef = React.createRef();
        _this.showInfo = function () {
            _this.setState({
                isShowedInfo: true
            });
            _this.timer = setTimeout(function () {
                return _this.setState({
                    isShowedInfo: false
                });
            }, 2000);
        };
        _this.validatePassword = function (value) {
            if (!value) {
                return 'Required';
            }
            else if (value.length < 6 || value.length > 32) {
                return _this.props.intl.formatMessage(__assign({}, messages.profile_minimum_symbols));
            }
            else if (!/[A-Z]/.test(value)) {
                return _this.props.intl.formatMessage(__assign({}, messages.profile_minimum_symbols));
            }
            else if (!/[0-9]/.test(value)) {
                return _this.props.intl.formatMessage(__assign({}, messages.profile_minimum_symbols));
            }
            return null;
        };
        _this.handleChange = function (event) {
            var _a = event.target, value = _a.value, name = _a.name;
            if (name === "Password") {
                var error = _this.validatePassword(value);
                _this.setState({ error: error });
            }
            _this.props.input.onChange(event);
        };
        return _this;
    }
    ProfileInput.prototype.componentWillUnmount = function () {
        clearTimeout(this.timer);
    };
    ProfileInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, input = _a.input, placeholder = _a.placeholder, type = _a.type, value = _a.value, darkTheme = _a.darkTheme;
        var error = this.state.error;
        var serverErrorCode = this.props.error;
        var inputCls = classNames(['profile-input-date', {
                'recharge-error': error,
                darkInput: darkTheme
            }]);
        var serverError = this.getErrorMessage(serverErrorCode);
        return (_jsxs("div", __assign({ className: "input", style: { position: "relative" } }, { children: [_jsx("input", __assign({ ref: this.inputRef }, input, { onChange: this.handleChange, placeholder: placeholder, type: type, className: inputCls, defaultValue: value, autoComplete: "new-password", style: { marginBottom: 5, backgroundColor: darkTheme ? "#4a4a4a" : "#fff", color: darkTheme && "#fff" } })), _jsxs("div", __assign({ style: { display: 'flex', flexDirection: 'column', gap: '10px' } }, { children: [serverError && serverError.name === input.name && (_jsx("div", __assign({ style: { color: "red", marginLeft: "5px" } }, { children: serverError.message }))), error && (_jsx("div", __assign({ style: { color: "red", marginLeft: "5px" } }, { children: error })))] })), _jsxs("div", { children: [this.inputRef.current &&
                            this.inputRef.current.value.length === 0 && input.name === "password" && (_jsxs("span", __assign({ style: {
                                width: "150px",
                                position: "absolute",
                                right: 10,
                                top: 15,
                                fontSize: 12,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end"
                            } }, { children: [_jsx(FormattedMessage, __assign({}, messages.profile_symbols)), _jsx("img", { onClick: this.showInfo, src: infoIcon, alt: "info-icon", className: classNames(['info-icon', { infoIconDark: darkTheme, isShowedInfo: this.state.isShowedInfo }]) }), this.state.isShowedInfo ? (_jsxs(React.Fragment, { children: [_jsx("img", { style: {
                                                position: "absolute",
                                                top: 20,
                                                right: -35,
                                                zIndex: 1000,
                                            }, src: infoAlert, alt: "info-alert" }), _jsx("span", __assign({ style: {
                                                position: "absolute",
                                                top: 40,
                                                right: '-35px',
                                                width: '170px',
                                                zIndex: 1001,
                                                fontSize: 11,
                                                color: darkTheme && "#525252"
                                            } }, { children: _jsx(FormattedMessage, __assign({}, messages.profile_minimum_symbols)) }))] })) : null] }))), this.inputRef.current &&
                            this.inputRef.current.value.length > 0 &&
                            this.inputRef.current.value.length < 40 ? (_jsxs("span", __assign({ onClick: function () { return _this.inputRef.current.focus(); }, style: {
                                width: "150px",
                                position: "absolute",
                                right: 10,
                                top: 15,
                                fontSize: 11,
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center"
                            } }, { children: [this.props.placeholder, input.name === "password" && (_jsxs(React.Fragment, { children: [_jsx("img", { onClick: this.showInfo, className: classNames([
                                                "info-icon",
                                                {
                                                    infoIconDark: darkTheme,
                                                    isShowedInfo: this.state.isShowedInfo
                                                }
                                            ]), src: infoIcon, alt: "info-icon" }), this.state.isShowedInfo ? (_jsxs(React.Fragment, { children: [_jsx("img", { style: {
                                                        position: "absolute",
                                                        top: 20,
                                                        right: -35,
                                                        zIndex: 1000
                                                    }, src: infoAlert, alt: "info-alert" }), _jsx("span", __assign({ style: {
                                                        position: "absolute",
                                                        top: 40,
                                                        right: "-35px",
                                                        width: "170px",
                                                        zIndex: 1001,
                                                        fontSize: 11,
                                                        color: darkTheme && "#525252"
                                                    } }, { children: _jsx(FormattedMessage, __assign({}, messages.profile_minimum_symbols)) }))] })) : null] }))] }))) : type === "date" ? (_jsx("span", __assign({ onClick: function () { return _this.inputRef.current.focus(); }, style: {
                                width: "150px",
                                position: "absolute",
                                right: 10,
                                top: 15,
                                fontSize: 12,
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center"
                            } }, { children: this.props.placeholder }))) : null] })] })));
    };
    return ProfileInput;
}(React.Component));
export default connect(function (state) { return ({
    darkTheme: state.application.get("darkTheme"),
    error: state.application.get('profile').updateResult,
    formType: state.application.get('profile').formType
}); })(injectIntl(ProfileInput));



// WEBPACK FOOTER //
// ./src/components/profile/ProfileInput.jsx